import Icons, { IconsProps } from '../../Icons';

export type MinimizeProps = IconsProps;

/**
 * - sm
 *   - 0.875 rem 14 px
 * - md (defalut)
 *   - 1 rem 16 px
 * - lg
 *   - 1.125 rem 18 px
 * - xl
 *   - 1.25 rem 20 px
 * - xl2 (big)
 *   - 1.5 rem 24 px
 * @param props
 * @returns
 */
export function Minimize(props: MinimizeProps) {
  return (
    <Icons {...props}>
      <path d="M22.468 22.468H1.532V21.42l7.8-4.68c.009-.005.028-.027.045-.045l.193-.18c.007-.013.03-.07.057-.137a.698.698 0 0 1 .043-.096c.012-.024.012-.056.012-.089l-.024-.31a.849.849 0 0 0-.062-.186l-.038-.046a.778.778 0 0 1-.064-.065c-.017-.019-.034-.042-.051-.066-2.773-2.157-2.805-5.968-2.805-6.007l.003-4.275C7.057 3.238 9.56 1.531 12 1.53c2.442 0 4.943 1.706 5.354 3.652l.008 4.33c0 .038-.032 3.851-2.767 5.963l-.089.11c-.018.021-.04.042-.062.063l-.07.088c.005.002-.01.06-.028.127-.013.05-.024.075-.034.102-.009.025-.005.057-.002.082l.01.158.001.069.046.086a.794.794 0 0 0 .085.179l.002.003c.006 0 .03.018.052.043a.79.79 0 0 0 .163.154l7.8 4.68v1.05zm-6.12-6.509l.205-.23c2.314-2.586 2.34-6.073 2.34-6.22l-.002-4.372a.719.719 0 0 0-.013-.132C18.348 2.011 14.895 0 12.005 0 9.107 0 5.653 2.012 5.122 5.005a.686.686 0 0 0-.013.134l-.003 4.372c0 .147.027 3.632 2.341 6.219l.205.23-7.281 4.37a.774.774 0 0 0-.371.656v1.498C0 23.32.68 24 1.515 24h20.97c.836 0 1.515-.68 1.515-1.516v-1.5a.767.767 0 0 0-.37-.655l-7.282-4.37z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
